import styled from 'styled-components';

export default styled.div`
  && {
    .btn-register {
      border-radius: 5px;
      background: #ff8a00;
      color: white;
      margin-right: 1rem;
      border: 1px solid #ff8a00;
    }
  }
`;
